import { PurchaseOrderUpdatedEvent } from '@rematter/frontend-lib-api-client/grpc/trade/purchase_order_events_pb';
import { Col, DiffViewer, FieldDisplay, IDField } from '@rematter/ui-web';

import { purchaseOrderStatusLabels } from '../enumLabels';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';

type PurchaseOrderUpdatedDetailProps = {
  event: PurchaseOrderUpdatedEvent;
};

export const PurchaseOrderUpdatedDetail = ({
  event,
}: PurchaseOrderUpdatedDetailProps) => {
  const t = useTranslations();
  const previous = event.previousPurchaseOrder;
  const current = event.updatedPurchaseOrder;

  if (!previous || !current) {
    return (
      <Col className="@PurchaseOrderUpdatedDetail items-center justify-center p-4 text-neutral/40">
        <span>{t.eventLogs.noDataAvailable}</span>
      </Col>
    );
  }

  const diffs = [
    {
      field: 'documentNumber',
      label: t.eventLogs.purchaseOrder.fields.documentNumber,
      previous: previous.documentNumber,
      current: current.documentNumber,
    },
    {
      field: 'status',
      label: t.eventLogs.purchaseOrder.fields.status,
      previous: purchaseOrderStatusLabels[previous.status],
      current: purchaseOrderStatusLabels[current.status],
    },
    {
      field: 'facilityId',
      label: t.eventLogs.purchaseOrder.fields.facilityId,
      previous: previous.facilityId?.value,
      current: current.facilityId?.value,
    },
    {
      field: 'accountId',
      label: t.eventLogs.purchaseOrder.fields.accountId,
      previous: previous.accountId?.value,
      current: current.accountId?.value,
    },
    {
      field: 'accountContactId',
      label: t.eventLogs.purchaseOrder.fields.accountContactId,
      previous: previous.accountContactId?.value,
      current: current.accountContactId?.value,
    },
    {
      field: 'counterpartyNumber',
      label: t.eventLogs.purchaseOrder.fields.counterpartyNumber,
      previous: previous.counterpartyNumber,
      current: current.counterpartyNumber,
    },
    {
      field: 'paymentCurrency',
      label: t.eventLogs.purchaseOrder.fields.paymentCurrency,
      previous: previous.paymentCurrency,
      current: current.paymentCurrency,
    },
    {
      field: 'notes',
      label: t.eventLogs.purchaseOrder.fields.notes,
      previous: previous.notes,
      current: current.notes,
    },
  ];

  return (
    <Col className="@PurchaseOrderUpdatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          {t.eventLogs.purchaseOrder.sectionTitle}
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={current.id?.value} />
          <FieldDisplay
            label={t.eventLogs.purchaseOrder.documentNumber}
            value={current.documentNumber}
          />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap1>
        <span className="mb-2 text-xs font-medium text-neutral/60">
          {t.eventLogs.purchaseOrder.changes}
        </span>
        <DiffViewer
          diffs={diffs}
          previousLabel={t.eventLogs.purchaseOrder.before}
          currentLabel={t.eventLogs.purchaseOrder.after}
        />
      </Col>
    </Col>
  );
};
